// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__YGDin","dragIcon":"SortableItem_dragIcon__3OqQr","disabled":"SortableItem_disabled__3MKnO"};